<template>
    <div id="main-container" class="px-0">
        <div class="scrollable-container" style="overflow-y: scroll;">
            <div class="button-container">
                <div class="d-flex align-items-center">
                    <font-awesome-icon icon="arrow-left" class="text-main" @click="goBack"
                        style="cursor: pointer; margin-top: 3px;" />
                    <span class="text-main font-weight-bold ml-2" @click="goBack" style="cursor: pointer;">
                        {{ $t('Cancel') }}
                    </span>
                </div>
            </div>
            <div class="card card-container">
                <img id="img-card" class="img-card" src="@/assets/images/logo-verification.png" />
                <h3 class="text-main font-weight-bold mt-3">{{ $t('Verify Email') }}</h3>
                <Form ref="registerForm" @submit="handleRegister" :validation-schema="schema"
                    :initial-values="initialValues">
                    <div class="form-group">
                        <label for="email">
                            {{ $t('Please check your inbox/spam folder and click the activation link that was sent') }}
                        </label>
                        <Field name="email" type="email" class="form-control" placeholder="{{ $t('Email Address') }}" />
                        <ErrorMessage name="email" class="error-feedback" />
                    </div>
                    <div class="form-group pt-3">
                        <button class="btn btn-main btn-block" :disabled="loading">
                            <span>{{ $t('Check Verification') }}</span>
                        </button>
                        <button class="btn btn-outline-secondary btn-block mt-3 mb-2" :disabled="loading || countdown > 0"
                            @click.prevent="resendEmail">
                            <span>{{ $t('Resend Email') }}</span>
                        </button>
                        <div class="text-center">
                            <span v-if="countdown > 0" class="text-muted">
                                {{ $t('Available again in {countdown} seconds', { countdown: countdown }) }}
                            </span>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
    name: "VerifyEmailPage",
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            email: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Email Address") }))
                .email(this.$t("Data is invalid!", { data: this.$t("Email Address") })),
        });

        return {
            initialValues: {
                email: '',
            },
            countdown: 0,
            loading: false,
            schema,
        };
    },
    created() {
        if (this.$route.query.userEmail) {
            this.initialValues.email = this.$route.query.userEmail;
        }
        if (this.$route.query.isWait) {
            this.countdown = 30;
            const countdownInterval = setInterval(() => {
                this.countdown--;
                if (this.countdown === 0) {
                    clearInterval(countdownInterval);
                }
            }, 1000);
        }
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
    },
    mounted() {
        if (this.loggedIn) {
            this.$router.push("/profile");
        }
    },
    methods: {
        goBack() {
            this.$router.push("/login");
        },
        handleRegister(user) {
            let loader = this.$loading.show();

            this.$store.dispatch("auth/verify", user).then(
                () => {
                    this.$router.push({
                        name: "Login",
                        query: {
                            isVerified: true,
                        },
                    });

                    loader.hide();
                },
                (error) => {
                    this.$vueAlert.alert((error.response && error.response.data && error.response.data.message) || error.message || error.toString(), null, 'error');
                    loader.hide();
                }
            );
        },
        resendEmail() {
            let loader = this.$loading.show();
            // Get the email input value from the form element
            const formElement = this.$refs.registerForm.$el;
            const email = formElement.email.value;

            this.$store.dispatch("auth/resend", email).then(
                (data) => {
                    this.$vueAlert.alert(data.message, null, 'success');
                    // Disable the resend button and start the countdown
                    this.countdown = 30;
                    const countdownInterval = setInterval(() => {
                        this.countdown--;
                        if (this.countdown === 0) {
                            clearInterval(countdownInterval);
                        }
                    }, 1000);

                    loader.hide();
                },
                (error) => {
                    this.$vueAlert.alert((error.response && error.response.data && error.response.data.message) || error.message || error.toString(), null, 'error');
                    loader.hide();
                }
            );
        },
    },
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.button-container {
    max-width: 375px;
    margin: 0 auto 15px;
    margin-top: 50px;

    @media screen and (max-width: 600px) {
        margin-top: 25px;
        padding-left: 15px;
    }
}

.card-container.card {
    max-width: 375px !important;
    padding: 40px 40px;
}

.card {
    background-color: #fff;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    /* margin-top: 50px; */
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.form-control {
    border-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}
</style>
